<div class="dashboard-container">
  <div class="itemContainer">
    <mat-card class="table-card">
      <app-data-table class="full-width-table" [displayedColumns]="displayedColumns"></app-data-table>
    </mat-card>
  </div>
</div>